import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchBrandsPrivate,
  SearchBrandsPrivateVariables
} from "./types/SearchBrandsPrivate";

export const searchBrandsPrivate = gql`
  ${pageInfoFragment}
  query SearchBrandsPrivate(
    $accountManager: ID
    $after: String
    $first: Int!
    $query: String!
    $status: SmopStatusEnum
  ) {
    search: brandsPrivate(
      after: $after
      first: $first
      status: $status
      filter: { search: $query, accountManager: $accountManager }
    ) {
      edges {
        node {
          id
          name
          legalName
          storeType
          tenants {
            id
            brand {
              id
            }
            storeName
            mall {
              id
              name
            }
          }
          brandGroup {
            id
            name
            vertical
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchBrandsPrivate,
  SearchBrandsPrivateVariables
>(searchBrandsPrivate);
